// extracted by mini-css-extract-plugin
module.exports = {"header":"_6i4AbHWyglD-E-nGYBK-TA==","button":"aeIkGA3F-tMe4T1y4fzR+w==","price":"IgK6EEfJ6hDqkr2gAGEXqw==","linethroughPrice":"XNZuJDqthQndK2vHPQR01Q=="};